import { Dropdown as FabricDropdown, IDropdownOption, IDropdownProps } from "@fluentui/react";
import React from "react";

import { DropdownOption } from "./DropdownOption";

export interface DropdownProps extends Pick<IDropdownProps, "label" | "placeholder" | "styles"> {
    selectedKey: string | undefined;
    options: DropdownOption[];
    testId?: string;
    onChange(key?: string): void;
}

export const Dropdown: React.FunctionComponent<DropdownProps> = (props: DropdownProps) => {
    const onChange = (_event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption): void => {
        props.onChange(option?.key.toString());
    };

    return (
        <FabricDropdown
            label={props.label}
            placeholder={props.placeholder}
            selectedKey={props.selectedKey}
            onChange={onChange}
            options={props.options}
            styles={props.styles}
            data-testid={props.testId}
        />
    );
};
